import { ACCESS_DENIED } from "client/utils/Permissions";


const BlankPage = () => {
  return (
    <>
      <div className="access-denied">
        <h1>ACCESS DENIED</h1>
        <h6>{ACCESS_DENIED}</h6>
      </div>
    </>
  );
};

export default BlankPage;
